<template>
    <div class="browse" @click="browse">
        <i-tooltip :disabled="!isBlankLayout">
            <div class="icon"><i-icon icon="stack" /></div>
            <div slot="body">
                <div class="drop-here">{{ msgDropHere }}</div>
                <a class="or-browse" v-if="$route.query.msgBrowse">{{ $route.query.msgBrowse }}</a>
                <a class="or-browse" v-else>{{ $t('msgDrop') }} <u>{{ $t('msgBrowse') }}</u></a>
            </div>
        </i-tooltip>

        <div class="drop-here">{{ msgDropHere }}</div>

        <a class="or-browse" v-if="$route.query.msgBrowse">{{ $route.query.msgBrowse }}</a>
        <a class="or-browse" v-else>{{ $t('msgDrop') }} <u>{{ $t('msgBrowse') }}</u></a>

        <input type="file" class="_display-none" ref="fileinput" @change="onFileSelected" />
    </div>
</template>

<style lang="scss">
@import '~@inkline/inkline/src/css/config';
@import '~@inkline/inkline/src/css/mixins';

.browse {
    .icon {
        cursor: pointer;
    }

    .or-browse {
        font-size: font-size('sm');
        color: $text-muted !important;
        cursor: pointer;
        margin: 0 !important;
    }
}
</style>

<script>
import StatusComponentMixin from "../../mixins/StatusComponentMixin";
import {
    IIcon
} from '@inkline/inkline/src/components';

export default {
    name: "Browse",
    mixins: [
        StatusComponentMixin
    ],
    components: {
        IIcon
    },
    methods: {
        onFileSelected(event) {
            const file = event.target.files[0];

            this.$store.dispatch("verify", file);
        },
        browse() {
            this.$refs.fileinput.click();
        }
    },
    computed: {
        msgDropHere: function() {
            return this.$route.query.msgDropHere || this.$t("msgDropHere");
        }
    }
};
</script>
